import { createStyles, rem } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  InlinePadding: {
    paddingInline: "6rem",
    "@media (max-width: 768px)": {
      paddingInline: "3rem",
    },
    "@media (max-width: 430px)": {
      paddingInline: "1rem",
    },
  },
  img: {
    width: "100%",
    height: "auto",
    maxWidth: "100%",
    minWidth: "50%",
    display: "block",
  },
  heroImg: {
    width: "100%",
    height: "auto",
    maxWidth: "73%",
    minWidth: "50%",
    display: "block",
    marginTop: 25,
  },
  heroSection: {
    position: "relative",
    padding: "4rem 0px",
  },
  heroContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    position: "relative",
    zIndex: 10,
  },
  primaryHeading: {
    fontFamily: "Inter",
    textAlign: "center",
    fontSize: "61px",
    fontWeight: "600",
    color: "#101828",
    lineHeight: "73px",
    "@media (max-width: 768px)": {
      fontSize: "28px",
      lineHeight: "46px",
    },
    "@media (max-width: 425px)": {
      lineHeight: "36px",
      margin: "1rem 0",
      fontSize: "28px !important",
    },
  },
  welcomeText: {
    backgroundColor: "#F5F5F5",
    mixBlendMode: "multiply",
    padding: "4px",
    borderRadius: "16px",
    marginBottom: "24px",
    "& > .mantine-1avyp1d": {
      padding: "2px 10px",
      fontSize: "14px",
      fontWeight: "500",
      color: "#262626",
      fontFamily: "Inter",
      borderRadius: 16,
      backgroundColor: "#FFF",
    },
  },
  heroSectionText: {
    fontFamily: "Inter",
    fontSize: "20px",
    width: "65%",
    fontWeight: 400,
    color: "#667085",
    marginTop: "24px",
    textAlign: "center",
    "@media (max-width: 1100px)": {
      fontSize: "17px",
    },
    "@media (max-width: 680px)": {
      width: "90%",
    },
  },
  heroSecDemoBtn: {
    margin: "24px 0px",
    background: "#262626",
    border: "1px solid #262626",
    color: "#FFF",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "600",
    width: "auto",
    height: "auto",
    lineHeight: "24px",
    padding: "12px 20px",
    borderRadius: "8px",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    cursor: "pointer",
    "&:hover": {
      background: "#262626",
      color: "#FFF",
      opacity: "0.8",
    },
    "@media (max-width: 768px)": {
      padding: ".5rem 2rem",
      fontSize: "14px",
      fontWeight: "600",
    },
  },
  heroSectionShadow: {
    position: "absolute",
    top: 0,
    left: 0,
    borderRadius: "80%",
    width: "100%",
    height: "100%",
    background: "rgba(255, 242, 207, 0.25)",
    filter: "blur(40px)",
    zIndex: 1,
  },
  primarySubHeading: {
    fontFamily: "Inter",
    fontSize: "28px",
    padding: ".5rem 0",
    textTransform: "capitalize",
    fontWeight: "600",
    lineHeight: "31px",
    "@media (max-width: 768px)": {
      fontSize: "24px",
      lineHeight: "46px",
    },
    "@media (max-width: 430px)": {
      lineHeight: "36px",
      fontSize: "20px !important",
    },
  },
  skypointOverviewSection: {
    marginTop: "2rem",
    marginBottom: "10rem",
    position: "relative",
    paddingTop: 30,
    overflow: "hidden",
    width: "100%",
    backgroundColor: "#262626",
    "& .leftImg": {
      position: "absolute",
      top: 50,
      left: 0,
      zIndex: 1,
    },
    "& .rightImg": {
      position: "absolute",
      bottom: 40,
      right: -35,
      zIndex: 1,
    },
    "& .contentBox": {
      position: "relative",
      zIndex: 10,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      maxWidth: 768,
      margin: "0 auto",
      textAlign: "center",
      "& .title": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontWeight: "600",
        color: "#FFAF4A",
      },
      "& .heading": {
        fontSize: 36,
        fontWeight: 600,
        fontFamily: "Inter",
        color: "#FFF",
      },
      "& .description": {
        fontFamily: "Inter",
        fontSize: 20,
        fontWeight: 400,
        color: "#E5E5E5",
      },
    },
  },
  featureHdng: {
    backgroundColor: "#FFFAEB",
    borderRadius: 16,
    padding: "4px 12px",
    width: "fit-content",
    height: "fit-content",
    color: "#B54708",
    fontSize: 16,
    fontWeight: 500,
    fontFamily: "Inter",
  },
  featureTitle: {
    fontSize: 30,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#101828",
  },
  featureDiscription: {
    color: "#667085",
    fontSize: 18,
    fontWeight: 400,
    fontFamily: "Inter",
  },
  innovationSection: {
    padding: "62px 64px",
    position: "relative",
    backgroundColor: "#262626",
    borderRadius: 24,
    marginTop: "10rem",
    overflow: "hidden",
    "& .heading": {
      fontSize: 30,
      marginTop: rem(40),
      fontWeight: 600,
      color: "#FFF",
      fontFamily: "Inter",
    },
    "& .description": {
      fontSize: 18,
      fontWeight: 400,
      fontFamily: "Inter",
      color: "#D4D4D4",
      marginTop: 5,
    },
    "& .boxesImg": {
      position: "absolute",
      bottom: -30,
      right: -5,
      zIndex: 1,
    },
  },
  dataAndSecurity: {
    width: "100%",
    paddingBlock: 18,
    backgroundColor: "#F9FAFB",
    marginTop: "70px",
    "& .maxWidthBox": {
      maxWidth: 1164,
      marginInline: "auto",
      marginTop: "40px",
      display: "flex",
      alignItems: "center",
      "& .col1": {
        width: "27%",
      },
      "& .col2": {
        width: "46%",
      },
      "& .col3": {
        width: "27%",
      },
      "@media (max-width: 850px)": {
        flexDirection: "column",
        "& .col1": {
          width: "80%",
        },
        "& .col2": {
          width: "80%",
        },
        "& .col3": {
          width: "80%",
        },
      },
    },
    "& .textContentWrapper": {
      marginInline: "auto",
      flexDirection: "column",
      alignItems: "center",
      maxWidth: 890,
      gap: 5,
    },
  },
  complianceAndReportingSection: {
    position: "relative",
    backgroundColor: "#262626",
    borderRadius: 24,
    overflow: "hidden",
    marginBlock: 70,
    "& .textParent": {
      marginLeft: 34,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      height: "100%",
      maxWidth: 560,
    },
    "& .heading": {
      fontSize: 30,
      fontWeight: 600,
      color: "#FFF",
      fontFamily: "Inter",
    },
    "& .description": {
      fontSize: 18,
      fontWeight: 400,
      fontFamily: "Inter",
      color: "#D4D4D4",
      marginTop: 5,
    },
    "& .boxesImg": {
      position: "absolute",
      top: 1,
      left: 12,
      zIndex: 1,
    },
  },
  text: {
    fontFamily: "Inter",
    fontSize: "20px",
    fontWeight: "400",
    lineHeight: "26px",
    padding: "1rem 0",
    "@media (max-width: 768px)": {
      fontSize: "16px",
      lineHeight: "22px",
    },
    "@media (max-width: 430px)": {
      lineHeight: "20px",
      fontSize: "14px !important",
    },
    // width: "700px",
  },
  primaryBtn: {
    background: theme.other.primaryBtn,
    color: "#FFFFFF",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    width: "auto",
    height: "auto",
    lineHeight: "24px",
    padding: "1rem 3rem",
    borderRadius: "8px",
    margin: "24px 0px",
    "&:hover": {
      background: theme.other.primaryBtn,
      color: "#FFFFFF",
      opacity: "0.8",
    },
    "@media (max-width: 768px)": {
      padding: ".5rem 2rem",
      fontSize: "14px",
      fontWeight: "500",
    },
  },
  styleFeatureBtn: {
    width: "480px",
    marginTop: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "14px 14px 14px 14px",
    padding: "5px 5px 0px 5px",
    background:
      "linear-gradient(to bottom, #000000 20%, rgba(255, 255, 255, 0.2))",
    "@media(max-width:500px)": {
      width: "300px",
    },
    boxShadow:
      "rgba(0, 0, 0, 0.05) 0px 1px 5px, rgba(0, 0, 0, 0.05) 0px 1px 10px",
  },

  features: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  featuresBtn: {
    background: theme.other.white,
    color: theme.other.black,
    borderColor: theme.other.black,
    borderWidth: "2px",
    borderStyle: "solid",
    fontFamily: "Inter",
    fontSize: "53px",
    fontWeight: "600",
    width: "auto",
    height: "auto",
    lineHeight: "76px",
    // padding: "1rem 2rem",
    borderRadius: "8px",
    margin: "24px 0px",
    padding: "0 20px",
    "&:hover": {
      background: theme.other.white,
      color: theme.other.black,
      borderColor: theme.other.black,
    },
    "@media (max-width: 768px)": {
      fontSize: "30px",
      // padding: "1rem",
    },
    "@media (max-width: 425px)": {
      fontSize: "20px",
      // padding: "1rem",
    },
  },
  Testimonials: {
    background: theme.other.white,
    color: theme.other.black,
    borderWidth: "2px",
    borderStyle: "solid",
    fontFamily: "Inter",
    fontSize: "63px",
    fontWeight: "600",
    width: "auto",
    height: "auto",
    lineHeight: "76px",
    padding: "1rem 3rem",
    borderRadius: "8px",
    margin: "24px 0px",
    "&:hover": {
      background: theme.other.white,
      color: theme.other.black,
    },
    "@media (max-width: 768px)": {
      margin: "10px 0px",
      fontSize: "30px",
      // padding: "1rem ",
    },
  },
  logoCarouselContainer: {
    margin: "6rem 0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    width: "100%",
    gap: "3rem",
    "@media (max-width: 768px)": {
      margin: "2rem 0px",
    },
    "@media (max-width: 500px)": {
      margin: "2rem 0px",
      gap: "1rem",
    },
  },
  TestimonialsContainer: {
    display: "flex",
    alignItems: "center",
    margin: "2rem",
  },
  testimonialsBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
  },
  testimonialsCard: {
    width: "90%",
    height: "219.21px",
    borderRadius: "10px",
    background: "#F3F3F3",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    padding: "1rem 3rem",
    marginTop: "-3rem",
    zIndex: "-1",
    "@media (max-width: 2570px)": {
      height: "400px",
    },
    "@media (max-width: 1800px)": {
      height: "400px",
    },
    "@media (max-width: 1200px)": {
      height: "440px",
    },
    "@media (max-width: 900px)": {
      height: "470px",
    },
    "@media (max-width: 700px)": {
      height: "600px",
      marginTop: "-2rem",
      padding: "1rem",
    },
    "@media (max-width: 425px)": {
      height: "550px",
    },
    "@media (max-width: 320px)": {
      height: "600px",
    },
  },
  testimonialsCardBlack: {
    background: theme.other.black,
    color: theme.other.white,
  },
  testimonialsImg: {
    // marginLeft: "3rem",
    // border: "7px solid #fff",
    borderRadius: "50%",
    width: "200px",
    height: "200px",
  },
  companyName: {
    // color: theme.other.black,
    fontFamily: "Inter",
    fontSize: "25px",
    fontWeight: "700",
    lineHeight: "36px",
    textAlign: "center",
    marginTop: "2rem",
  },
  companyType: {
    fontSize: "20px",
    margin: ".5rem 0px",
  },
  message: {
    fontFamily: "Inter",
    fontSize: "20px",
    fontWeight: "400",
    lineHeight: "26px",
    textAlign: "center",
    "@media (max-width: 430px)": {
      lineHeight: "20px",
      fontSize: "15px",
    },
  },
  customerInfo: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "end",
    width: "100%",
    marginTop: "1rem",
    marginRight: "4rem",
  },
  customerName: {
    fontFamily: "Inter",
    fontSize: "24px",
    fontWeight: "500",
    lineHeight: "26px",
    textAlign: "right",
    width: "100%",
    marginTop: "1rem",
    margin: ".5rem 2rem",
  },
  position: {
    fontFamily: "Inter",
    fontSize: "20px",
    fontWeight: "450",
    lineHeight: "26px",
    textAlign: "right",
    width: "100%",
    // margin: "1rem 2rem",
  },
  carouselImgFlex: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  CarouselContainer: {
    "& .mantine-Carousel-indicator": {
      background: theme.other.yellowColor,
      width: "15px",
      height: "15px",
      borderRadius: "50%",
    },
    "& .mantine-Carousel-control": {
      border: "none",
      boxShadow: "none",
      background: "transparent",
      margin: "0 -4rem",
      "@media (max-width: 768px)": {
        margin: "0 -3rem",
      },
      "@media (max-width: 430px)": {
        margin: "0 -2rem",
      },
    },
  },
  MobileFlexDirection: {
    "@media (max-width: 834px)": {
      flexDirection: "column-reverse",
    },
  },
  logo: {
    width: "10%",
    aspectRatio: "3/2",
    objectFit: "contain",
    "@media (max-width: 500px)": {
      width: "20%",
    },
  },
  carouselContainer: {
    position: "relative",
  },
  carouselArrow: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    zIndex: 10,
    padding: 0,
    margin: "0 3rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      fontSize: 30,
    },
  },
  testimonialCarouselArrow: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    zIndex: 10,
    padding: 0,
    margin: "3rem -1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      fontSize: 30,
    },
  },
  leftArrow: {
    left: theme.spacing.md,
  },
  rightArrow: {
    right: theme.spacing.md,
  },
  customDotListStyle: {
    " .react-multi-carousel-dot button": {
      border: "none",
    },
    " .react-multi-carousel-dot--active button": {
      background: theme.other.yellowColor,
    },
  },
  testimonialDotListStyle: {
    " .react-multi-carousel-dot button": {
      // marginTop: "4rem",
      border: "none",
    },
  },
}));
export default useStyles;
